import { api, ApiError } from "@/api/api";
import { ChangeIsChildPresentedData } from "@/api/images-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useChangeIsChildPresented(imageId: string) {
  const queryClient = useQueryClient();

  return useMutation<{}, ApiError, ChangeIsChildPresentedData>({
    mutationKey: ["POST", "images", imageId, "changeIsChildPresented"],
    mutationFn: (data) =>
      api.images.imageId.changeIsChildPresented.post({ imageId }, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GET", "images", imageId] });
      // TODO: Invalidate only the affected episode, not all of them (need to know episode id of the image)
      queryClient.invalidateQueries({ queryKey: ["GET", "episodeDetails"] });
    },
  });
}
